export default __webpack_public_path__ + "static/media/lorcana_common.bd6ff44d.svg";